import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageDashboardsTable} from "../../UI/Main/ManageDashboardsTable";

const ManageDashboards = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManageDashboardsTable />} />
        </div>
    );
};

export default ManageDashboards;
